import React from 'react';
import Hero from '../components/Hero';
import TrustStrip from '../components/TrustStrip';
import ServiceCards from '../components/ServiceCards';
import AboutSection from '../components/AboutSection';
import StatsCounter from '../components/StatsCounter';
import ConditionsGrid from '../components/ConditionsGrid';
import FeaturedTestimonial from '../components/FeaturedTestimonial';
import UpcomingEvents from '../components/UpcomingEvents';
import EventBanner from '../components/EventBanner';
import TrainingPrograms from '../components/TrainingPrograms';
import Team from '../components/Team';
import AwardsCertificates from '../components/AwardsCertificates';
import Blog from '../components/Blog';
import VisitUs from '../components/VisitUs';
import AppointmentForm from '../components/AppointmentForm';

// Rhythm intent:
//   Hero (teal)             →
//   TrustStrip (white)      →
//   ConditionsGrid (white)  →
//   ServiceCards (cream)    →
//   AboutSection (white)    →
//   StatsCounter (dark)     →
//   FeaturedTestimonial(dark→cream)
//   TrainingPrograms (white)→
//   Team (cream)            →
//   AwardsCertificates(white)→
//   Blog (cream)            →
//   VisitUs (white)         →
//   AppointmentForm (dark)
function HomePage() {
  return (
    <>
      <EventBanner />
      <Hero />
      <TrustStrip />
      <ConditionsGrid />
      <ServiceCards />
      <AboutSection />
      <StatsCounter />
      <FeaturedTestimonial />
      <UpcomingEvents />
      <TrainingPrograms />
      <Team />
      <AwardsCertificates />
      <Blog />
      <VisitUs />
      <AppointmentForm />
    </>
  );
}

export default HomePage;
